import React from "react";

import styles from "./styles.module.scss";

const CheckboxGroup = ({ checkboxes }) => {
    return checkboxes.map((checkbox, index) => (
        <div className={styles.checkbox} key={index}>
            {checkbox}
        </div>
    ));
};

export default CheckboxGroup;
